import React from "react";

class ShopMarker extends React.Component {
  render() {
    return <div className="c-shop-marker" />;
  }
}

export default ShopMarker;
